import { API, Designer } from "@brg/api";
import { bProfile, useProfile } from "@brg/auth";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";

const useContextButtons = (team, currentTab) => {
    const { i18n: { language } } = useTranslation();
    const profile = useProfile();

    const {
        teamId,
        moderationType,
        buttons: contextButtonsProps,
    } = team;

    const { isChannel,channelType } = isTeamChannel(moderationType);

    const activeTab = useMemo(() => {
        return team?.tabs?.find(tab => tab.path === currentTab)
    }, [currentTab, team]) 
    const activeTabHasButtons = !!activeTab?.buttons?.length;

    const owner = useMemo(
        () => (profile && team && team?.owners?.find(
            (owner: Designer<'Global'>) => owner?.accountId === profile?.accountId) || undefined)
        , [team, isChannel]) as Designer | undefined

    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

    const isNotAGroupChannelParticipant = useMemo(() => {
    if (!isChannel || moderationType !== ModerationType.ChannelGroupOrCourse) return true
    return (team?.ownersIDs?.includes(profile?.accountId) || team?.channelCommentWhiteListIds?.includes(profile?.accountId) || isModer)
    }, [isChannel, profile, moderationType, isModer])

    const isTeamMember = useMemo(() => (team && profile && (team?.membersIDs?.includes(profile?.accountId) || team?.ownersIDs?.includes(profile?.accountId))), [profile, team]);

    const hideSwitcherButtons = useMemo(() => (team?.isSwitchButtonVisible && !isTeamMember), [team]);


    const chatButton = useMemo(() => {
        if (!isNotAGroupChannelParticipant) {
            return []
        }

        return [
            {
                actionType: "link",
                anchor: { label: "", value: "" },
                hidden: false,
                href: [{ lang: "ru", name: `/chat/${teamId}` }, { lang: "en", name: "" }],
                isRequired: false,
                text: [{ lang: "ru", name: "Перейти в чат" }, { lang: "en", name: "Go to chat" }],
                textMobile: [{ lang: "ru", name: "Перейти в чат" }, { lang: "en", name: "Go to chat" }],
                type: "hollow"
            },
        ]
    } , [isNotAGroupChannelParticipant])

    const channelButtons = [
        {
            actionType: "link",
            anchor: { label: "", value: "" },
            hidden: false,
            href: [{ lang: "ru", name: `/team-edit/${teamId}` }, { lang: "en", name: "" }],
            isRequired: false,
            text: [{ lang: "ru", name: "Редактировать my mediiia" }, { lang: "en", name: "Edit my mediiia" }],
            textMobile: [{ lang: "ru", name: "Редактировать my mediiia" }, { lang: "en", name: "Edit my mediiia" }],
            type: "hollow"
        }
    ]
    const showChannelButtons = useMemo(() => {
        return !!owner && isChannel
    }, [owner, profile, isChannel])

    const contextButtons = useMemo(() => {
        if (channelType === ModerationType.ChannelGroupOrCourse) {
            return API.toLang([...chatButton, ...(showChannelButtons ? channelButtons : [])], language)
        }
        return isChannel ? API.toLang([...(showChannelButtons ? channelButtons : [])], language) : activeTabHasButtons ? activeTab?.buttons : contextButtonsProps;
    }, [isChannel, chatButton, channelType, showChannelButtons, channelButtons, language, contextButtonsProps, activeTabHasButtons])

    return {
        contextButtons,
        hideSwitcherButtons,
    }
}

export default useContextButtons;import { API, Designer } from "@brg/api";
import { bProfile, useProfile } from "@brg/auth";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";

const useContextButtons = (team, currentTab) => {
    const { i18n: { language } } = useTranslation();
    const profile = useProfile();

    const {
        teamId,
        moderationType,
        buttons: contextButtonsProps,
    } = team;

    const { isChannel,channelType } = isTeamChannel(moderationType);

    const activeTab = useMemo(() => {
        return team?.tabs?.find(tab => tab.path === currentTab)
    }, [currentTab, team]) 
    const activeTabHasButtons = !!activeTab?.buttons?.length;

    const owner = useMemo(
        () => (profile && team && team?.owners?.find(
            (owner: Designer<'Global'>) => owner?.accountId === profile?.accountId) || undefined)
        , [team, isChannel]) as Designer | undefined

    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

    const isNotAGroupChannelParticipant = useMemo(() => {
    if (!isChannel || moderationType !== ModerationType.ChannelGroupOrCourse) return true
    return (team?.ownersIDs?.includes(profile?.accountId) || team?.channelCommentWhiteListIds?.includes(profile?.accountId) || isModer)
    }, [isChannel, profile, moderationType, isModer])

    const isTeamMember = useMemo(() => (team && profile && (team?.membersIDs?.includes(profile?.accountId) || team?.ownersIDs?.includes(profile?.accountId))), [profile, team]);

    const hideSwitcherButtons = useMemo(() => (team?.isSwitchButtonVisible && !isTeamMember), [team]);


    const chatButton = useMemo(() => {
        if (!isNotAGroupChannelParticipant) {
            return []
        }

        return [
            {
                actionType: "link",
                anchor: { label: "", value: "" },
                hidden: false,
                href: [{ lang: "ru", name: `/chat/${teamId}` }, { lang: "en", name: "" }],
                isRequired: false,
                text: [{ lang: "ru", name: "Перейти в чат" }, { lang: "en", name: "Go to chat" }],
                textMobile: [{ lang: "ru", name: "Перейти в чат" }, { lang: "en", name: "Go to chat" }],
                type: "hollow"
            },
        ]
    } , [isNotAGroupChannelParticipant])

    const channelButtons = [
        {
            actionType: "link",
            anchor: { label: "", value: "" },
            hidden: false,
            href: [{ lang: "ru", name: `/team-edit/${teamId}` }, { lang: "en", name: "" }],
            isRequired: false,
            text: [{ lang: "ru", name: "Редактировать my mediiia" }, { lang: "en", name: "Edit my mediiia" }],
            textMobile: [{ lang: "ru", name: "Редактировать my mediiia" }, { lang: "en", name: "Edit my mediiia" }],
            type: "hollow"
        }
    ]
    const showChannelButtons = useMemo(() => {
        return !!owner && isChannel
    }, [owner, profile, isChannel])

    const contextButtons = useMemo(() => {
        if (channelType === ModerationType.ChannelGroupOrCourse) {
            return API.toLang([...chatButton, ...(showChannelButtons ? channelButtons : [])], language)
        }
        return isChannel ? API.toLang([...(showChannelButtons ? channelButtons : [])], language) : activeTabHasButtons ? activeTab?.buttons : contextButtonsProps;
    }, [isChannel, chatButton, channelType, showChannelButtons, channelButtons, language, contextButtonsProps, activeTabHasButtons])

    return {
        contextButtons,
        hideSwitcherButtons,
    }
}

export default useContextButtons;